import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import {
  ENTITY,
  ENTITY_NAME_TOKEN,
  SHARED_ENTITY_ACTIONS_TOKEN,
  SHARED_ENTITY_SELECTORS_TOKEN,
} from './+state/constants';
import { EntityEffects } from './+state/effects';
import { SharedFacade } from './+state/facade';
import * as fromEntity from './+state/reducer';
import { sharedSelectors } from './+state/selectors';
import { LoadAllGuard } from './guards/load-all.guard';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromEntity.ENTITY_FEATURE_KEY,
      fromEntity.rawReducer
    ),
    EffectsModule.forFeature([EntityEffects]),
  ],
  providers: [
    LoadAllGuard,
    SharedFacade,
    {
      provide: SHARED_ENTITY_ACTIONS_TOKEN,
      useValue: fromEntity.sharedActions,
    },
    {
      provide: SHARED_ENTITY_SELECTORS_TOKEN,
      useValue: sharedSelectors,
    },
    {
      provide: ENTITY_NAME_TOKEN,
      useValue: ENTITY,
    },
  ],
})
export class AppSharedBilancioPartecipataRigaModule {}
